/**
 * Draggable Background plugin for jQuery
 *
 * v1.2.4
 *
 * Copyright (c) 2014 Kenneth Chung
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 */

(function ($, undefined) {
  $.widget("printq.bgDraggable", $.ui.mouse, {
    version: "1.0.0",
    widgetEventPrefix: "bgDrag",
    options: {
      addClasses: true,
      axis: false,
      bound: true,
      // callbacks
      drag: null,
      start: null,
      stop: null
    },
    _create: function () {
      if (this.options.addClasses) {
        this.element.addClass("ui-bgDraggable");
      }
      if (this.options.disabled) {
        this.element.addClass("ui-bgDraggable-disabled");
      }
      this._mouseInit();
    },
    _destroy: function () {
      this.element.removeClass(
        "ui-bgDraggable ui-bgDraggable-dragging ui-bgDraggable-disabled"
      );
      this._mouseDestroy();
    },
    _mouseStart: function (event) {
      var o = this.options;

      this.element.addClass("ui-bgDraggable-dragging");

      //Cache the elementSize
      this._cacheElementSize();

      //Cache the bgSize
      this._cacheBgSize();

      //Cache the bgPosition
      this._cacheBgPosition();
      this.originalBgPosition = this.bgPosition;

      this.originalClientX = event.clientX;
      this.originalClientY = event.clientY;

      this._setBound();
      this._cacheBoundsAdjustments();

      if (this._trigger("start", event) === false) {
        this._clear();
        return false;
      }

      this._mouseDrag(event, true);

      return true;
    },
    _mouseDrag: function (event, noPropagation) {
      this.bgPosition = this._generatePosition(event);

      if (!noPropagation) {
        var ui = this._uiHash();
        if (this._trigger("drag", event, ui) === false) {
          this._clear();
          return false;
        }
      }

      this.element[0].style.backgroundPosition =
        this.bgPosition.left + "px " + this.bgPosition.top + "px ";

      return false;
    },
    _mouseStop: function (event) {
      var ui = this._uiHash();
      if (this._trigger("stop", event, ui) !== false) {
        this._clear();
      }
      return false;
    },
    _cacheElementSize: function () {
      this.elementSize = {
        width: this.element.innerWidth(),
        height: this.element.innerHeight()
      };
    },
    _cacheBgSize: function () {
      var pos =
        this.element.css("background-size").match(/(-?\d+).*?\s(-?\d+)/) || [];

      this.bgSize = {
        width: parseFloat(pos[1]) || 0,
        height: parseFloat(pos[2]) || 0
      };
    },
    _generateBoundsAdjustments: function (type) {
      var o = this.options;
      if (o.bound) {
        var adjustments = lfpGlobalStore.getEditor.dim.canvasFormatDimByFormat;
        var adjustments1 = lfpGlobalStore.getEditor.dim.canvasImageDimByFormat;
        if (typeof type == "string") {
          if (type == "width") {
            return {
              low: adjustments.right + adjustments1.right,
              hi: adjustments.left + adjustments1.left
            };
          }
          if (type == "height") {
            return {
              low: adjustments.bottom + adjustments1.bottom,
              hi: adjustments.top + adjustments1.top
            };
          }
        }
      }

      return {
        low: 0,
        hi: 0
      };
    },
    _cacheBoundsAdjustments: function () {
      this.boundsAdjW = this._generateBoundsAdjustments("width");
      this.boundsAdjH = this._generateBoundsAdjustments("height");
    },
    _cacheBgPosition: function () {
      var pos =
        this.element.css("background-position").match(/(-?\d+).*?\s(-?\d+)/) ||
        [];

      this.bgPosition = {
        left: parseFloat(pos[1]) || 0,
        top: parseFloat(pos[2]) || 0
      };
    },
    _clear: function () {
      this.element.removeClass("ui-bgDraggable-dragging");
    },
    _trigger: function (type, event, ui) {
      ui = ui || this._uiHash();
      $.ui.plugin.call(this, type, [event, ui]);
      return $.Widget.prototype._trigger.call(this, type, event, ui);
    },
    _limit: function (low, hi, adjustments, value, bool) {
      if (arguments.length === 3 || bool) {
        low -= adjustments.low;
        hi += adjustments.hi;
        if (low <= hi) {
          if (value <= low) return low;
          if (value >= hi) return hi;
        } else {
          if (value <= hi) return hi;
          if (value > low) return low;
        }
      }
      return value;
    },
    _generatePosition: function (event) {
      var o = this.options;
      var x0 = 0;
      var y0 = 0;
      var x = 0;
      var y = 0;

      if (typeof event != "undefined") {
        var x0 = this.originalClientX;
        var y0 = this.originalClientY;
        var x = event.clientX;
        var y = event.clientY;
      }

      var xPos =
        o.axis === "y"
          ? this.originalBgPosition.left
          : this._limit(
              this.bound.width,
              0,
              this.boundsAdjW,
              this.originalBgPosition.left + x - x0,
              o.bound
            );
      var yPos =
        o.axis === "x"
          ? this.originalBgPosition.top
          : this._limit(
              this.bound.height,
              0,
              this.boundsAdjH,
              this.originalBgPosition.top + y - y0,
              o.bound
            );

      return {
        top: yPos,
        left: xPos
      };
    },

    updateOnResize: function () {
      var o = this.options;
      //Cache the elementSize
      this._cacheElementSize();

      //Cache the bgSize
      this._cacheBgSize();

      //Cache the bgPosition
      this._cacheBgPosition();
      this.originalBgPosition = this.bgPosition;

      this._setBound();
      this._cacheBoundsAdjustments();

      var isLimitW = false;
      var isLimitH = false;

      if (
        this.originalBgPosition.left !=
        this._limit(
          this.bound.width,
          0,
          this.boundsAdjW,
          this.originalBgPosition.left,
          o.bound
        )
      )
        isLimitW = true;
      if (
        this.originalBgPosition.top !=
        this._limit(
          this.bound.height,
          0,
          this.boundsAdjH,
          this.originalBgPosition.top,
          o.bound
        )
      )
        isLimitH = true;
      if (isLimitW || isLimitH) {
        this.bgPosition = this._generatePosition();
        if (!isLimitW) this.bgPosition.left = this.originalBgPosition.left;
        if (!isLimitH) this.bgPosition.top = this.originalBgPosition.top;
        this.element[0].style.backgroundPosition =
          this.bgPosition.left + "px " + this.bgPosition.top + "px ";
        return this._uiHash();
      }

      return false;
    },
    _setBound: function () {
      var o = this.options;
      this.bound = {
        width: 0,
        height: 0
      };

      if (o.bound) {
        this.bound = {
          width: this.elementSize.width - this.bgSize.width,
          height: this.elementSize.height - this.bgSize.height
        };
      }
    },
    plugins: {},
    _uiHash: function () {
      return {
        elementSize: this.elementSize,
        bgSize: this.bgSize,
        bgPosition: this.bgPosition
      };
    }
  });
})(jQuery);
